import { ApolloLink } from '@apollo/client';

const costMetrics = {};

const storeCost = cost => {
  if (typeof cost === 'undefined' || !cost) return;

  Object.assign(costMetrics, cost);
};

const costReportingLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    storeCost(response?.extensions?.cost);

    return response;
  });
});

export default costReportingLink;

export const costReport = () => {
  return costMetrics;
};

export const resetCostReport = () => {
  for (const prop of Object.getOwnPropertyNames(costMetrics)) {
    delete costMetrics[prop];
  }
};

export const includeFieldCost = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (window.INCLUDE_FIELD_COSTS) {
    return true;
  }

  const params = new URLSearchParams(window.location?.search);

  return params.get('graphql-cost-include-fields') === 'true';
};
